import {Grid} from "@mui/system";

import {DefaultCardStructure} from "components";
import {Controller, useFormContext} from "react-hook-form";
import ProcessTextField from "views/ProcessDetails/refactor/components/ProcessTextField";
import {Process} from "views/ProcessDetails/refactor/types/process.types";

type Props = {
  loadIndex: number;
};

const NcmField = ({loadIndex}: Props) => {
  const {control, setValue} = useFormContext<Process>();

  return (
    <DefaultCardStructure title="NCM's" hasDivider titleMarginBottom={15}>
      <Grid container>
        <Grid size={12}>
          <Controller
            name={`processLoads.${loadIndex}.ncmDescription`}
            control={control}
            render={({field: {value, onChange}}) => (
              <ProcessTextField
                multiline
                minRows={4}
                maxRows={8}
                label="NCM's"
                name={`processLoads.${loadIndex}.ncmDescription`}
                placeholder="Descreva os NCM's"
                value={value ?? ""}
                onChange={onChange}
              />
            )}
          />
        </Grid>
      </Grid>
    </DefaultCardStructure>
  );
};

export default NcmField;
